import React, { useState, useEffect } from 'react';

interface PathInputFormProps {
  onFetchData: (edaPath: string, modelPath: string) => void;
  isLoading: boolean;
  initialEdaPath: string;
  initialModelPath: string;
}

export const PathInputForm: React.FC<PathInputFormProps> = ({ 
  onFetchData, 
  isLoading, 
  initialEdaPath, 
  initialModelPath 
}) => {
  const [edaPath, setEdaPath] = useState<string>(initialEdaPath);
  const [modelPath, setModelPath] = useState<string>(initialModelPath);

  useEffect(() => {
    setEdaPath(initialEdaPath);
  }, [initialEdaPath]);

  useEffect(() => {
    setModelPath(initialModelPath);
  }, [initialModelPath]);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (edaPath || modelPath) { // Fetch only if at least one path is provided
        onFetchData(edaPath, modelPath);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="path-input-form">
      <div className="form-row">
          <div className="form-group">
            <label htmlFor="edaPath">EDA Ergebnis Pfad:</label>
            <input
              type="text"
              id="edaPath"
              value={edaPath}
              onChange={(e) => setEdaPath(e.target.value)}
              placeholder="z.B. eda-results/eda_mydata_timestamp.json"
            />
          </div>
          <div className="form-group">
            <label htmlFor="modelPath">Modell Pfad:</label>
            <input
              type="text"
              id="modelPath"
              value={modelPath}
              onChange={(e) => setModelPath(e.target.value)}
              placeholder="z.B. models/model_mymodel_timestamp.joblib"
            />
          </div>
      </div>
      <button type="submit" disabled={isLoading || (!edaPath && !modelPath)}>
        {isLoading ? 'Lade...' : 'Daten Laden'}
      </button>
    </form>
  );
}; 